import { TabContext, TabPanel } from '@mui/lab'
import { Tab, Tabs, Typography } from '@mui/material'
import Box from 'components/common/Box'
import Paper from 'components/common/Paper'
import Stack from 'components/common/Stack'
import Contact from 'components/query/Contact'
import Query from 'components/query/Query'
import React, { Component } from 'react'

export default class QueryContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: "1",
        };

        this.handleTabChange = this.handleTabChange.bind(this);
    }
    handleTabChange(e, newValue) {
        this.setState({ value: newValue });
    }

    componentDidMount() {
        this.props.getOwnerListDataAction();
        this.props.getHostListDataAction()
    }



    render() {

        return (
            <>

                <Stack sx={{ marginTop: "1.2rem" }}>
                    <Paper sx={{ p: 3, mt: 3.5 }}>
                        <Stack sx={{ marginTop: "1.2rem" }}>
                            <Typography variant="h6" color="#707070">
                                Query
                            </Typography>

                        </Stack>
                        <TabContext value={this.state.value}>
                            <Box
                                sx={{ borderBottom: 1, borderColor: "divider", marginTop: 3 }}
                            >
                                <Tabs
                                    value={this.state.value}
                                    onChange={this.handleTabChange}
                                    aria-label="lab API tabs example"
                                >
                                    <Tab
                                        label="Owner"
                                        sx={{ textTransform: "none" }}
                                        value="1"
                                        index={0}
                                    />
                                    <Tab
                                        label="Host"
                                        sx={{ textTransform: "none" }}
                                        value="2"
                                        index={1}
                                    />
                                </Tabs>
                            </Box>
                            <TabPanel value={"1"} index={0} sx={{ px: 0 }}>
                                <Query data={this.props.OwnerListData} />
                            </TabPanel>
                            <TabPanel value={"2"} index={1} sx={{ px: 0 }}>
                                <Contact data={this.props.HostListData} />
                            </TabPanel>
                        </TabContext>
                    </Paper>

                </Stack>





                {/* <Query/> */}
            </>
        )
    }
}
